import FormFeesCard from 'routes/PaymentSettings/FormFeesCard/FormFeesCard';

export default FormFeesCard;
